import React, { Fragment } from 'react'
import imgCirculo from '../../assets/img/a-editora-img-circulos.png';
import SlideCard from '../SlideCard/SlideCard';
import './PublishingCompany.css';
import ScrollTo from '../../helpers/scroll';
export default class PublishingCompany extends React.Component {

    render() {
        return (
            <Fragment>
                <section id="PublishingCompany" className=" publishingcompany">
                    <div className="row">
                        <div className="col-xl-6 col-lg-12">
                            <h1 className="title-publisher">A EDITORA</h1>
                            <h3 className="title-publisher-2 text-color">Qualidade em todo processo editorial</h3>
                            <p className="text">
                                É inegável que o universo de novos leitores amplia-se a cada
                                dia, sempre em busca de textos agradáveis, bem escritos e
                                com apresentação gráfica impecável. Estamos convictos de
                                que todos esses fatores são essenciais para o sucesso dos
                                Escritores e a satisfação de quem os lê.
                                Neste sentido, temos a missão de levar ao mercado editorial
                                livros impressos e digitais (e-books) de qualidade,
                                contribuindo, assim para a difusão do conhecimento e a
                                entrada de novos autores no mercado editorial.
                                Nossa equipe é formada por profissionais e parceiros com
                                larga experiência nesse mercado, contando com experts nas
                                áreas de revisão gramatical, design editorial, impressão e
                                acabamento.
                            </p>
                        </div>
                        <div className="col-xl-6 col-lg-12 publishingCompany-image">
                            <img className="publishingCompany-image-figure" src={imgCirculo} alt="" />
                        </div>

                    </div>
                    <h4 className="text-color title-paper title-publisher-2">Seu papel é escrever, o nosso, publicar!</h4>
                    <div className="publish-container-button">
                        <button onClick={() => ScrollTo('Publish')} className="button-publishCompany mt-3 mt-4 mb-2" >QUERO PUBLICAR</button>
                    </div>
                </section>
                <div className="container publishingcompany-comentarios">
                    <SlideCard />
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PublishingCompany/PublishingCompany.js